import { Globals } from "../CoreApp/Globals";

export function doUnzip() {
  Globals._fileMgr.DoUnzip();
}
